module.exports = __webpack_public_path__ + "static/media/PNCBank_Logo.348137cf.jpg";